import React from 'react';
import StaffWorkStandardsGeneric from './generics/StaffWorkStandardsGeneric';
import { checkWorkStandardFileAction, downloadWorkStandardAction } from '../../services/request';

export default function StaffWorkStandards ({ manager }) {
  return (
    <StaffWorkStandardsGeneric
      manager={manager}
      downloadDocumentAction={downloadWorkStandardAction}
      checkDocumentAction={checkWorkStandardFileAction}
      title="Standardy Pracy"
      serializerFieldName="work_standard_documents"
    />
  );
};
